import { NavigateFunction } from "react-router-dom";

export function redirectIfIsNotInitialized(param: any, path: string, navigate: NavigateFunction) {
    if (!param) {
        navigate(path);
        return;
    }
}

export function redirectWithBoolean(bool: boolean, path: string, navigate: NavigateFunction) {
    if (bool) {
        navigate(path);
        return;
    }
}